import { contactHistoryClient } from '@/api/axios';

export interface IContactHistory {
  contactId: string;
  agentUsername: string;
  queueName: string;
  matchingCluster?: string;
  channel: string;
  initiationTimestamp: string;
  disconnectTimestamp: string;
  Frazionario?: string;
  ticketNumber?: string;
  contactPDL?: string;
  Nome?: string;
  Cognome?: string;
  Matricola?: string;
  CodUser?: string;
  Ufficio?: string;
  TelefonoCaller?: string;
  TelefonoUfficio?: string;
}

export const getContactHistory = async (agentUsername: string): Promise<IContactHistory[]> => {
  const { data } = await contactHistoryClient.get<IContactHistory[]>('', {
    params: { agentUsername }
  });

  return data;
};

export const saveContactHistory = async (contact: IContactHistory): Promise<void> => {
  console.log('[CONTACT HISTORY API] /storico/contatti', contact);
  await contactHistoryClient.post('', contact);
};
